import { formatScore } from '../../helpers/reputationView';

interface ReputationGaugeProps {
  score: number;
}

export function ReputationGauge({ score }: ReputationGaugeProps) {
  const clamped = Math.max(0, Math.min(100, score));
  const shown = formatScore(clamped);
  const radius = 40;
  const circumference = 2 * Math.PI * radius;
  const dash = (clamped / 100) * circumference;
  const gap = circumference - dash;

  return (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      aria-label={`Score: ${shown}`}
    >
      <circle
        cx="50"
        cy="50"
        r={radius}
        fill="none"
        stroke="var(--border-default)"
        strokeWidth="8"
      />
      <circle
        cx="50"
        cy="50"
        r={radius}
        fill="none"
        stroke="var(--accent-emeraude)"
        strokeWidth="8"
        strokeDasharray={`${dash} ${gap}`}
        strokeLinecap="round"
        transform="rotate(-90 50 50)"
      />
      <text
        x="50"
        y="55"
        textAnchor="middle"
        fontSize="20"
        fill="var(--text-primary)"
      >
        {shown}
      </text>
    </svg>
  );
}
